import React, { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  action?: string;
  any?: string[];
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ action, any: anyActions, children }) => {
  const { hasPermission, hasAnyPermission, loading, user, requiresPasswordChange } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#0A0F1C' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Force password change redirect (Prompt #52)
  if (requiresPasswordChange && location.pathname !== '/change-password/first-login') {
    return <Navigate to="/change-password/first-login" replace />;
  }

  if (action || anyActions) {
    let allowed = false;
    if (action) allowed = hasPermission(action);
    else if (anyActions) allowed = hasAnyPermission(anyActions);
    if (!allowed) return <Navigate to="/forbidden" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
